export default function SiteService($http, DummyApi, $q, API_LEGACY) {
    let service = this;

    service.bodyClasses = [];
    service.deviceMode = "desktop"; //will be set on page init core.js
    service.currentBreakpoint = "lg"; //will be set on page init by core.js
    service.firstLoad = true;
    service.tmpBodyClasses = {};
    service.headerHeight = 100; //will be set on page init by core.js

    service.scrollToSearchResults = false; // used to determine whether to scroll to searchResult when changing url

    service.activeTab = {
        //
        mypage: { index: 1 },
        search: { index: 2 },
    };

    service.asideState = {
        open: false,
        position: null,
    };

    service.getSite = function () {
        //return the promise directly.
        var url = API_LEGACY + "/Site/GetSite";
        return $http.post(url, { cache: true }).then(function (result) {
            return result.data;
        });
    };
    service.getGetLocations = function () {
        //return the promise directly.
        var url = API_LEGACY + "/Location/GetLocations";
        return $http.post(url, { cache: true }).then(function (result) {
            return result.data;
        });
    };
    service.getMenuNodes = function () {
        //return the promise directly.
        var url = API_LEGACY + "/Site/GetMenuNodes";
        return $http.post(url, { cache: true }).then(function (result) {
            return result.data;
        });
    };
    service.getHeroImages = function () {
        //return the promise directly.
        var url = API_LEGACY + "/Site/GetFeatureImages";
        return $http.post(url, { cache: true }).then(function (result) {
            return result.data;
        });
    };
    service.getPage = function (nodeId) {
        var url = API_LEGACY + "/site/GetPage/" + nodeId + "/";

        return $http.get(url).then(function (result) {
            return result.data;
        });
    };
    service.getTerms = function () {
        // TO DO ::: HIGH ::: API legacy does not return the terms??

        var url = API_LEGACY + "/site/GetTerms/";
        return $http.post(url).then(function (result) {
            return result.data;
        });
    };
    service.getFooter = function () {
        if (DummyApi.isEnabled()) {
            return $q.resolve(DummyApi.getFooter());
        }
        // avail param : nodeId

        var url = API_LEGACY + "/Site/GetFooter/";

        return $http({
            url: url,
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: {
                cache: true,
            },
        }).then(function (result) {
            return result.data;
        });
    };

    service.addBodyClass = function (classToAdd, prop) {
        service.tmpBodyClasses[prop] = classToAdd;

        var aBodyClasses = [];

        for (var property in service.tmpBodyClasses) {
            if (service.tmpBodyClasses.hasOwnProperty(property)) {
                // do stuff
                aBodyClasses.push(service.tmpBodyClasses[property]);
            }
        }

        service.bodyClasses = aBodyClasses.join(" ");
    };

    return service;
}
